import { Translations } from '@repo/types';
import { QuantityInputItem } from '../shared/types';
import { capitalize } from '../shared/transformers';

/**
 * Get default guest type inputs for leads forms
 *
 * Creates simple adult/children counters with no capacity limits.
 * Used in leads forms where we just need to count travelers.
 *
 * @param translations - Translation object
 * @returns Default quantity input items (adults: 1, children: 0)
 */
export const getDefaultGuestTypes = (translations: Translations): QuantityInputItem[] => [
    {
        id: 'adults',
        label: capitalize(translations.adult.plural),
        value: 1,
        min: 0,
        max: Infinity,
        disabled: false,
    },
    {
        id: 'children',
        label: capitalize(translations.children.plural),
        value: 0,
        min: 0,
        max: Infinity,
        disabled: false,
    },
];

/**
 * Update a quantity in the simple inputs array
 *
 * Pure function - returns new array with updated item.
 *
 * @param items - Current quantity input items
 * @param id - ID of item to update
 * @param value - New value
 * @returns New array with updated item
 */
export const updateSimpleQuantity = (
    items: QuantityInputItem[],
    id: string,
    value: number,
): QuantityInputItem[] => {
    return items.map((item) => (item.id === id ? { ...item, value } : item));
};

/**
 * Get total number of guests across all simple inputs
 *
 * @param items - Quantity input items
 * @returns Total sum of all values
 */
export const getTotalGuests = (items: QuantityInputItem[]): number => {
    return items.reduce((sum, item) => sum + item.value, 0);
};
